// extracted by mini-css-extract-plugin
export var btn = "bottomCta-module--btn--CZ8DF";
export var descr = "bottomCta-module--descr--UcRl4";
export var img = "bottomCta-module--img--Ltv3t";
export var secondContainer = "bottomCta-module--secondContainer--6AqxM";
export var section = "bottomCta-module--section--IxMp-";
export var textBlock = "bottomCta-module--textBlock--MuYft";
export var title = "bottomCta-module--title--EKj1H";
export var wrapper = "bottomCta-module--wrapper--96QHw";